// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-page hr {
  margin: 0; }

.message-page .user-list {
  padding: 10px; }

.message-page .message-row {
  margin-top: 10px; }
  .message-page .message-row .col-3 {
    text-align: center; }
    .message-page .message-row .col-3 img {
      max-width: 40px; }

.message-page .message {
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px;
  white-space: -moz-pre-wrap;
  /* Firefox */
  white-space: -pre-wrap;
  /* ancient Opera */
  white-space: -o-pre-wrap;
  /* newer Opera */
  white-space: pre-wrap;
  /* Chrome; W3C standard */
  word-wrap: break-word;
  /* IE */ }

.message-page .from-user .message {
  background: #4330ff;
  color: white; }

.message-page .to-user .rounded-circle {
  margin-left: 10px; }

.message-page .to-user .message {
  background: #eaeaea; }

.message-page .message-form {
  background-color: #eaeaea;
  padding: 10px; }

.message-page .message-submit-button {
  float: right;
  color: #4330ff;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 3px 50px 3px 50px;
  display: inline-block; }
  .message-page .message-submit-button:hover {
    cursor: pointer;
    color: black; }

.message-page .message-submit-button-disabled {
  color: gray; }
  .message-page .message-submit-button-disabled:hover {
    color: gray; }

@media only screen and (max-width: 845px) {
  .message-page img {
    height: 55px;
    width: 55px; } }

@media only screen and (max-width: 630px) {
  .message-page img {
    height: 38px;
    width: 38px; }
  .message-page .col-2 {
    margin-top: 10px;
    padding: 0; } }

.list-messages {
  position: relative; }
  .list-messages .user-list {
    padding: 10px; }
  .list-messages .list-message-row {
    padding-top: 5px; }
    .list-messages .list-message-row .fa-angle-right {
      position: absolute;
      right: 0%;
      top: 40%;
      font-size: 2em;
      color: #c0c0c0; }
    .list-messages .list-message-row .timeframe {
      position: absolute;
      right: 0%;
      top: 80%;
      font-size: 1em;
      color: #c0c0c0; }
  .list-messages .list-message {
    color: black;
    padding: 10px 0 5px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 80%; }

.list-messages:hover {
  background-color: #f2f2f2; }

hr:hover {
  background-color: white; }

.list-messages a:hover {
  text-decoration: none; }

.list-messages[data-count]:after {
  position: absolute;
  right: 0%;
  top: 40%;
  font-size: 90%;
  content: attr(data-count);
  padding: .6em;
  border-radius: 999px;
  line-height: .75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold; }

.chars-left {
  font-size: 12px;
  color: #606060;
  margin: 5px 0 5px 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/Messages/messages.css"],"names":[],"mappings":"AAAA;EACE,SAAS,EAAE;;AAEb;EACE,aAAa,EAAE;;AAEjB;EACE,gBAAgB,EAAE;EAClB;IACE,kBAAkB,EAAE;IACpB;MACE,eAAe,EAAE;;AAEvB;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,OAAO,EAAE;;AAEX;EACE,mBAAmB;EACnB,YAAY,EAAE;;AAEhB;EACE,iBAAiB,EAAE;;AAErB;EACE,mBAAmB,EAAE;;AAEvB;EACE,yBAAyB;EACzB,aAAa,EAAE;;AAEjB;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB,EAAE;EACvB;IACE,eAAe;IACf,YAAY,EAAE;;AAElB;EACE,WAAW,EAAE;EACb;IACE,WAAW,EAAE;;AAEjB;EACE;IACE,YAAY;IACZ,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,YAAY;IACZ,WAAW,EAAE;EACf;IACE,gBAAgB;IAChB,UAAU,EAAE,EAAE;;AAElB;EACE,kBAAkB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,gBAAgB,EAAE;IAClB;MACE,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,cAAc;MACd,cAAc,EAAE;IAClB;MACE,kBAAkB;MAClB,SAAS;MACT,QAAQ;MACR,cAAc;MACd,cAAc,EAAE;EACpB;IACE,YAAY;IACZ,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU,EAAE;;AAEhB;EACE,yBAAyB,EAAE;;AAE7B;EACE,uBAAuB,EAAE;;AAE3B;EACE,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,eAAe;EACf,cAAc;EACd,sBAAsB,EAAE","sourcesContent":[".message-page hr {\n  margin: 0; }\n\n.message-page .user-list {\n  padding: 10px; }\n\n.message-page .message-row {\n  margin-top: 10px; }\n  .message-page .message-row .col-3 {\n    text-align: center; }\n    .message-page .message-row .col-3 img {\n      max-width: 40px; }\n\n.message-page .message {\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 10px;\n  white-space: -moz-pre-wrap;\n  /* Firefox */\n  white-space: -pre-wrap;\n  /* ancient Opera */\n  white-space: -o-pre-wrap;\n  /* newer Opera */\n  white-space: pre-wrap;\n  /* Chrome; W3C standard */\n  word-wrap: break-word;\n  /* IE */ }\n\n.message-page .from-user .message {\n  background: #4330ff;\n  color: white; }\n\n.message-page .to-user .rounded-circle {\n  margin-left: 10px; }\n\n.message-page .to-user .message {\n  background: #eaeaea; }\n\n.message-page .message-form {\n  background-color: #eaeaea;\n  padding: 10px; }\n\n.message-page .message-submit-button {\n  float: right;\n  color: #4330ff;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  border-radius: 5px;\n  padding: 3px 50px 3px 50px;\n  display: inline-block; }\n  .message-page .message-submit-button:hover {\n    cursor: pointer;\n    color: black; }\n\n.message-page .message-submit-button-disabled {\n  color: gray; }\n  .message-page .message-submit-button-disabled:hover {\n    color: gray; }\n\n@media only screen and (max-width: 845px) {\n  .message-page img {\n    height: 55px;\n    width: 55px; } }\n\n@media only screen and (max-width: 630px) {\n  .message-page img {\n    height: 38px;\n    width: 38px; }\n  .message-page .col-2 {\n    margin-top: 10px;\n    padding: 0; } }\n\n.list-messages {\n  position: relative; }\n  .list-messages .user-list {\n    padding: 10px; }\n  .list-messages .list-message-row {\n    padding-top: 5px; }\n    .list-messages .list-message-row .fa-angle-right {\n      position: absolute;\n      right: 0%;\n      top: 40%;\n      font-size: 2em;\n      color: #c0c0c0; }\n    .list-messages .list-message-row .timeframe {\n      position: absolute;\n      right: 0%;\n      top: 80%;\n      font-size: 1em;\n      color: #c0c0c0; }\n  .list-messages .list-message {\n    color: black;\n    padding: 10px 0 5px 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 80%; }\n\n.list-messages:hover {\n  background-color: #f2f2f2; }\n\nhr:hover {\n  background-color: white; }\n\n.list-messages a:hover {\n  text-decoration: none; }\n\n.list-messages[data-count]:after {\n  position: absolute;\n  right: 0%;\n  top: 40%;\n  font-size: 90%;\n  content: attr(data-count);\n  padding: .6em;\n  border-radius: 999px;\n  line-height: .75em;\n  color: white;\n  background: rgba(255, 0, 0, 0.85);\n  text-align: center;\n  min-width: 2em;\n  font-weight: bold; }\n\n.chars-left {\n  font-size: 12px;\n  color: #606060;\n  margin: 5px 0 5px 10px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
